import { useCompareDateRangeParams } from './useCompareDateRangeParams/useCompareDateRangeParams';
import { useDateRangeParams } from './useDateRangeParams/useDateRangeParams';
import { useGroupByParams } from './useGroupByParams/useGroupByParams';
export const useAnalyticsParams = () => {
    const { options: dateRangeOptions, dateRange, setDateRange } = useDateRangeParams();
    const { options: compareDateRangeOptions, compareDateRange, setCompareDateRange, } = useCompareDateRangeParams(dateRange);
    const { options: groupByOptions, groupBy, setGroupBy } = useGroupByParams(dateRange);
    return {
        dateRange: {
            value: dateRange,
            options: dateRangeOptions,
            onSelect: setDateRange,
        },
        compareDateRange: {
            value: compareDateRange,
            options: compareDateRangeOptions,
            onSelect: setCompareDateRange,
        },
        groupBy: {
            value: groupBy,
            options: groupByOptions,
            onSelect: setGroupBy,
        },
    };
};
